import { Alert, Box, CircularProgress, FormControl, InputLabel, Modal, Snackbar } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import useQuery from "../../hooks/useQuery";
import servLogin from "../../services/login/servLogin";
import styles from "./RedefinirSenha.module.css";
import { style as modalStyle } from "../../components/Loading/Loading";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { HelperText } from "../../components/Errors/HelperText";

let recuperarSchema = yup.object({
    Email: yup.string().email("O e-mail deve ser válido").required("Este campo é obrigatório"), 
    Senha: yup.string().matches(
        /^.*(?=.{6,})(?=.*\d)((?=.*[aA-zZ]){1}).*$/,
        "A senha deve conter no mínimo 6 caracteres, contendo letras e números"
    ).required("Este campo é obrigatório"), 
    ConfirmarSenha: yup.string().required("Este campo é obrigatório").oneOf([yup.ref('Senha')], "Senhas devem ser iguais")
});

const RedefinirSenha = () => {
    let query = useQuery();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [novaSenha, setNovaSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");
    const { control, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(recuperarSchema) });

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("error");
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }


    const enviarRecuperarSenha = handleSubmit(async (data) => {
        try {

            setIsLoading(true);

            var dto = {
                Email: data.Email,
                Senha: data.Senha,
                Hash: query.get('tkn')
            };
    
            await servLogin.redefinirSenha(dto);

            setIsLoading(false);
            setSeverity("success");
            setOpen(true);
            setAlertMessage("Senha alterada com sucesso");

            setTimeout(() => {
                navigate("/");
            }, 2500);

        } catch (err) {
            setIsLoading(false);

            setOpen(true);
            setSeverity("error");
            setAlertMessage(err?.response?.data?.Message);
            return;
        }
    });

    return (
        <main className={styles.redefinirMain}>
            <form onSubmit={enviarRecuperarSenha} className={styles.formularioRedefinicao}>  
                <h3>Redefinição de senha</h3>
                <Controller 
                    name="Email"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles.camposLargos}>
                            <InputLabel htmlFor="redefinir-email" shrink style={{ color: "#b8b8b8" }}>E-mail</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Seu email"
                                id="redefinir-email"
                                error={!!errors?.Email}
                                {...field}
                                className={`${errors?.Email ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors?.Email && (
                                <HelperText text={errors?.Email?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller 
                    name="Senha"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles.camposLargos}>
                            <InputLabel htmlFor="redefinir-senha" shrink style={{ color: "#b8b8b8" }}>Nova Senha</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Nova senha"
                                id="redefinir-senha"
                                type="password"
                                error={!!errors?.Senha}
                                {...field}
                                className={`${errors?.Senha ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors?.Senha && (
                                <HelperText text={errors?.Senha?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller 
                    name="ConfirmarSenha"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles.camposLargos}>
                            <InputLabel htmlFor="redefinir-senha" shrink style={{ color: "#b8b8b8" }}>Confirmar Senha</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Confirmar senha"
                                id="redefinir-confirmacao"
                                type="password"
                                error={!!errors?.ConfirmarSenha}
                                {...field}
                                className={`${errors?.ConfirmarSenha ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors?.ConfirmarSenha && (
                                <HelperText text={errors?.ConfirmarSenha?.message} />
                            )}
                        </FormControl>
                    )}
                />


                <BlueHoverButton variant="contained" type="submit" sx={{ width: 150 }}>Salvar</BlueHoverButton>
            </form>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}> 
                    <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
            </Modal>
        </main>

    )
}

export { RedefinirSenha }